import axios from "axios";
import { track, reset, EVENTS } from "./analyticsService";

/**
 * Ends the web session: the auth header, the analytics identity and what the
 * app keeps in localStorage (the access token among it). `method` is the
 * logged_out event's reason. The caller sends the browser on afterwards; a
 * full page load is what makes the rest of the app see the session is gone.
 */
export const endSession = (method) => {
  axios.defaults.headers.common.Authorization = undefined;
  track(EVENTS.LOGGED_OUT, { method });
  reset();
  localStorage.clear();
};
